// New Modules Data - ADA Upgrade

// ===========================================
// SCORECARD DATA - Positions sur les textes
// ===========================================
export const scorecardData = {
  pt: {
    title: "Scorecard",
    subtitle: "O que apoiamos, emendamos ou opomos",
    description: "A nossa postura construtiva materializa-se através de posições claras e fundamentadas sobre textos importantes.",
    categories: {
      supported: { label: "Apoiado", color: "green", description: "Textos que apoiamos" },
      amended: { label: "Emendado", color: "yellow", description: "Textos que propomos melhorar" },
      opposed: { label: "Oposto", color: "red", description: "Textos que contestamos" }
    },
    items: [
      {
        id: "sc-001",
        title: "Lei de Descentralização Fiscal",
        position: "supported",
        date: "2025-01-15",
        tags: ["Institucional", "Económico"],
        summary: "Esta lei reforça a autonomia financeira das autarquias locais, alinhada com a nossa visão de províncias economicamente soberanas.",
        why: "Permite às regiões cobrar impostos locais e gerir diretamente parte das receitas fiscais, promovendo o desenvolvimento territorial.",
        proposal: null,
        impact: "Melhor distribuição de recursos, desenvolvimento local acelerado, responsabilização dos eleitos."
      }
    ],
    cta: {
      share: "Partilhar esta posição",
      subscribe: "Receber próximas posições",
      back: "Voltar ao Scorecard"
    }
  },
  fr: {
    title: "Scorecard",
    subtitle: "Ce que nous soutenons, amendons ou combattons",
    description: "Notre posture constructive se matérialise par des positions claires et argumentées sur les textes importants.",
    categories: {
      supported: { label: "Soutenu", color: "green", description: "Textes que nous soutenons" },
      amended: { label: "Amendé", color: "yellow", description: "Textes que nous proposons d'améliorer" },
      opposed: { label: "Combattu", color: "red", description: "Textes que nous contestons" }
    },
    items: [
      {
        id: "sc-001",
        title: "Loi sur la décentralisation fiscale",
        position: "supported",
        date: "2025-01-15",
        tags: ["Institutionnel", "Économique"],
        summary: "Cette loi renforce l'autonomie financière des collectivités territoriales, alignée avec notre vision des provinces économiquement souveraines.",
        why: "Elle permet aux régions de lever des impôts locaux et de gérer directement une partie des recettes fiscales, favorisant le développement territorial.",
        proposal: null,
        impact: "Meilleure répartition des ressources, développement local accéléré, responsabilisation des élus locaux."
      },
      {
        id: "sc-002",
        title: "Projet de réforme du Code électoral",
        position: "amended",
        date: "2025-01-20",
        tags: ["Institutionnel"],
        summary: "Le projet contient des avancées mais manque de garanties sur la représentation proportionnelle et l'accès équitable aux médias.",
        why: "Les seuils de représentation restent trop élevés et les règles de financement des campagnes favorisent les partis établis.",
        proposal: "Nous proposons : (1) Abaissement du seuil à 3%, (2) Temps d'antenne équitable garanti, (3) Plafonnement strict des dépenses avec contrôle indépendant.",
        impact: "Pluralisme renforcé, compétition électorale plus équitable, confiance citoyenne restaurée."
      },
      {
        id: "sc-003",
        title: "Loi sur le contrôle des réseaux sociaux",
        position: "opposed",
        date: "2025-02-01",
        tags: ["Social", "Institutionnel"],
        summary: "Ce texte, présenté comme une lutte contre la désinformation, contient des dispositions liberticides et des pouvoirs excessifs de censure.",
        why: "Les définitions floues de 'fausse information' et l'absence de contrôle judiciaire préalable ouvrent la porte aux abus.",
        proposal: "Nous demandons : (1) Définitions précises et limitatives, (2) Contrôle judiciaire obligatoire avant toute suspension, (3) Voies de recours effectives.",
        impact: "Protection des libertés fondamentales, débat public préservé, État de droit respecté."
      },
      {
        id: "sc-004",
        title: "Budget d'investissement agricole 2025",
        position: "supported",
        date: "2025-01-10",
        tags: ["Économique", "Local CI"],
        summary: "L'augmentation de 40% du budget dédié aux infrastructures agricoles répond à nos propositions sur la souveraineté alimentaire.",
        why: "Les investissements dans le stockage, la chaîne du froid et les pistes rurales sont essentiels pour réduire les pertes post-récolte.",
        proposal: null,
        impact: "Revenus paysans en hausse, baisse de l'inflation alimentaire, compétitivité accrue à l'export."
      },
      {
        id: "sc-005",
        title: "Réforme du statut des enseignants",
        position: "amended",
        date: "2025-01-25",
        tags: ["Social", "Éducation"],
        summary: "Des avancées salariales bienvenues, mais le texte ne traite pas la question fondamentale de la formation continue et de l'évaluation.",
        why: "Sans mécanisme de formation et d'évaluation, les hausses salariales n'amélioreront pas la qualité de l'enseignement.",
        proposal: "Nous proposons d'ajouter : (1) 5 jours de formation obligatoire par an, (2) Évaluation par les pairs, (3) Primes liées aux résultats des élèves.",
        impact: "Enseignants mieux formés, motivation accrue, amélioration mesurable des apprentissages."
      }
    ],
    cta: {
      share: "Partager cette position",
      subscribe: "Recevoir les prochaines positions",
      back: "Retour au Scorecard"
    }
  },
  en: {
    title: "Scorecard",
    subtitle: "What we support, amend or oppose",
    description: "Our constructive stance materializes through clear and reasoned positions on important texts.",
    categories: {
      supported: { label: "Supported", color: "green", description: "Texts we support" },
      amended: { label: "Amended", color: "yellow", description: "Texts we propose to improve" },
      opposed: { label: "Opposed", color: "red", description: "Texts we contest" }
    },
    items: [
      {
        id: "sc-001",
        title: "Fiscal Decentralization Law",
        position: "supported",
        date: "2025-01-15",
        tags: ["Institutional", "Economic"],
        summary: "This law strengthens the financial autonomy of local authorities, aligned with our vision of economically sovereign provinces.",
        why: "It allows regions to levy local taxes and directly manage part of tax revenues, promoting territorial development.",
        proposal: null,
        impact: "Better resource distribution, accelerated local development, accountability of elected officials."
      }
    ],
    cta: {
      share: "Share this position",
      subscribe: "Receive upcoming positions",
      back: "Back to Scorecard"
    }
  }
};

// ===========================================
// GOUVERNANCE DATA
// ===========================================
export const gouvernanceData = {
  pt: {
    title: "Governança & Ética",
    subtitle: "Como funcionamos",
    sections: [
      {
        id: "organisation",
        title: "Organização",
        icon: "Users",
        content: [
          "A ADA está estruturada em torno de um Comité de Coordenação nacional e Círculos locais.",
          "O Comité define as orientações estratégicas e assegura a coerência da mensagem.",
          "Os Círculos locais são autónomos na organização das suas atividades, em conformidade com a Carta."
        ]
      }
    ],
    cta: {
      report: "Ler o último relatório",
      charter: "Consultar a Carta"
    }
  },
  fr: {
    title: "Gouvernance & Éthique",
    subtitle: "Comment nous fonctionnons",
    sections: [
      {
        id: "organisation",
        title: "Organisation",
        icon: "Users",
        content: [
          "L'ADA est structurée autour d'un Comité de Coordination national et de Cercles locaux.",
          "Le Comité définit les orientations stratégiques et assure la cohérence du message.",
          "Les Cercles locaux sont autonomes dans l'organisation de leurs activités, dans le respect de la Charte."
        ]
      },
      {
        id: "decisions",
        title: "Principes de décision",
        icon: "Scale",
        content: [
          "Transparence : toute décision majeure est documentée et accessible aux membres.",
          "Collégialité : les orientations stratégiques sont débattues collectivement.",
          "Subsidiarité : ce qui peut être décidé localement l'est localement."
        ]
      },
      {
        id: "ethique",
        title: "Engagement éthique",
        icon: "Shield",
        content: [
          "Déclaration d'intérêts obligatoire pour tous les membres du Comité.",
          "Interdiction de cumul avec des fonctions dans des entreprises bénéficiant de marchés publics.",
          "Engagement de transparence sur les sources de financement.",
          "Tolérance zéro pour toute forme de corruption ou de clientélisme."
        ]
      },
      {
        id: "finances",
        title: "Transparence financière",
        icon: "FileText",
        content: [
          "Publication trimestrielle des comptes simplifiés.",
          "Détail des sources de financement (dons, cotisations, subventions).",
          "Rapport annuel audité par un cabinet indépendant.",
          "Accessibilité des rapports à tous les adhérents et au public."
        ]
      }
    ],
    cta: {
      report: "Lire le dernier rapport",
      charter: "Consulter la Charte"
    }
  },
  en: {
    title: "Governance & Ethics",
    subtitle: "How we operate",
    sections: [
      {
        id: "organisation",
        title: "Organization",
        icon: "Users",
        content: [
          "ADA is structured around a national Coordination Committee and local Circles.",
          "The Committee defines strategic orientations and ensures message consistency.",
          "Local Circles are autonomous in organizing their activities, in compliance with the Charter."
        ]
      }
    ],
    cta: {
      report: "Read the latest report",
      charter: "View the Charter"
    }
  }
};

// ===========================================
// FAQ DATA
// ===========================================
export const faqData = {
  pt: {
    title: "Perguntas frequentes",
    subtitle: "Mitos & Respostas",
    categories: [
      {
        id: "posture",
        title: "A nossa postura",
        questions: [
          {
            q: "Estão na oposição?",
            a: "Somos uma força construtiva e contributiva. Não estamos nem no apoio cego, nem na oposição sistemática. Julgamos cada texto pelo seu mérito: apoiamos o que é útil, emendamos o que é perfectível, combatemos o que é perigoso."
          }
        ]
      }
    ],
    cta: {
      scorecard: "Ver Scorecard",
      notes: "Ver as nossas Notas",
      contact: "Outra pergunta?"
    }
  },
  fr: {
    title: "Questions fréquentes",
    subtitle: "Mythes & Réponses",
    categories: [
      {
        id: "posture",
        title: "Notre posture",
        questions: [
          {
            q: "Êtes-vous dans l'opposition ?",
            a: "Nous sommes une force constructive et contributive. Nous ne sommes ni dans le soutien aveugle, ni dans l'opposition systématique. Nous jugeons chaque texte sur le fond : nous soutenons ce qui est utile, nous amendons ce qui est perfectible, nous combattons ce qui est dangereux."
          },
          {
            q: "Pourquoi soutenez-vous certaines mesures du gouvernement ?",
            a: "Parce que notre objectif est le bien commun, pas le conflit. Quand une mesure va dans le bon sens, la cohérence exige de le reconnaître. Notre crédibilité se construit sur la preuve, pas sur le bruit."
          },
          {
            q: "Comment vous différenciez-vous des autres partis ?",
            a: "Par notre méthode : chaque position est argumentée, chaque proposition est chiffrée, chaque engagement est vérifiable. Nous publions nos positions (Scorecard) et nos notes de proposition. La transparence est notre marque."
          }
        ]
      },
      {
        id: "programme",
        title: "Notre programme",
        questions: [
          {
            q: "Que changerait l'ADA en 12 mois au pouvoir ?",
            a: "Nos 3 premières mesures : (1) Création de l'Agence de Planification Territoriale, (2) Lancement du programme '1000 PME Fournisseurs', (3) Réforme du calendrier scolaire. Ces mesures sont détaillées dans nos Notes de proposition."
          },
          {
            q: "Êtes-vous pour ou contre la décentralisation ?",
            a: "Nous sommes pour une décentralisation réelle, pas cosmétique. Cela signifie des provinces avec des compétences claires, des ressources propres et une capacité de décision autonome. La souveraineté économique territoriale est au cœur de notre projet."
          },
          {
            q: "Quelle est votre position sur la monnaie ?",
            a: "Nous prônons la souveraineté monétaire progressive. Cela passe d'abord par le renforcement de l'intégration économique régionale et la création d'outils de politique monétaire adaptés à nos réalités."
          }
        ]
      },
      {
        id: "adhesion",
        title: "Adhésion & Dons",
        questions: [
          {
            q: "Comment sont utilisés les dons ?",
            a: "100% des dons financent nos activités : formation des volontaires, impression de matériel, organisation d'événements, développement numérique. Nous publions un rapport trimestriel détaillant l'utilisation des fonds."
          },
          {
            q: "Puis-je adhérer sans donner d'argent ?",
            a: "Absolument. Votre temps et vos compétences sont aussi précieux que l'argent. Vous pouvez contribuer comme volontaire digital, relais terrain, chercheur ou mobilisateur."
          },
          {
            q: "Les dons sont-ils déductibles des impôts ?",
            a: "La déductibilité dépend de la législation en vigueur et de notre statut. Consultez notre page Transparence pour les détails actualisés."
          }
        ]
      }
    ],
    cta: {
      scorecard: "Voir le Scorecard",
      notes: "Consulter nos Notes",
      contact: "Une autre question ?"
    }
  },
  en: {
    title: "Frequently Asked Questions",
    subtitle: "Myths & Answers",
    categories: [
      {
        id: "posture",
        title: "Our stance",
        questions: [
          {
            q: "Are you in the opposition?",
            a: "We are a constructive and contributive force. We are neither in blind support nor in systematic opposition. We judge each text on its merits: we support what is useful, we amend what is perfectible, we fight what is dangerous."
          }
        ]
      }
    ],
    cta: {
      scorecard: "View Scorecard",
      notes: "View our Notes",
      contact: "Another question?"
    }
  }
};

// ===========================================
// TRANSPARENCE DATA
// ===========================================
export const transparenceData = {
  pt: {
    title: "Transparência",
    subtitle: "Dados Pessoais & Finanças",
    sections: [],
    cta: {
      contact: "Contacte-nos",
      download: "Descarregar relatório"
    }
  },
  fr: {
    title: "Transparence",
    subtitle: "Données personnelles & Finances",
    sections: [
      {
        id: "donnees",
        title: "Vos données personnelles",
        content: [
          {
            label: "Données collectées",
            text: "Nom, prénom, email, téléphone (optionnel), ville, message. Ces données sont nécessaires pour vous contacter et organiser nos activités."
          },
          {
            label: "Finalité",
            text: "Communication sur nos activités, organisation d'événements locaux, appels à contribution. Jamais de revente à des tiers."
          },
          {
            label: "Durée de conservation",
            text: "Vos données sont conservées tant que vous êtes membre actif, puis archivées 3 ans après votre dernière interaction."
          },
          {
            label: "Vos droits",
            text: "Accès, rectification, suppression, portabilité. Contactez-nous à privacy@ada.org pour exercer vos droits."
          }
        ]
      },
      {
        id: "finances",
        title: "Transparence financière",
        content: [
          {
            label: "Fréquence",
            text: "Rapport trimestriel publié dans les 30 jours suivant la fin du trimestre."
          },
          {
            label: "Contenu",
            text: "Sources de financement (dons individuels, cotisations, subventions), dépenses par catégorie, solde de trésorerie."
          },
          {
            label: "Audit",
            text: "Rapport annuel audité par un cabinet indépendant, accessible à tous."
          }
        ],
        reports: [
          { period: "T4 2024", status: "À venir", url: null },
          { period: "T1 2025", status: "À venir", url: null }
        ]
      }
    ],
    cta: {
      contact: "Nous contacter",
      download: "Télécharger le rapport"
    }
  },
  en: {
    title: "Transparency",
    subtitle: "Personal Data & Finances",
    sections: [],
    cta: {
      contact: "Contact us",
      download: "Download report"
    }
  }
};

// ===========================================
// TERRAIN DATA - Résultats & Actions
// ===========================================
export const terrainData = {
  pt: {
    title: "Resultados & Terreno",
    subtitle: "O movimento em ação",
    description: "As nossas ações concretas, mês após mês. Um movimento julga-se pelos seus resultados.",
    timeline: [],
    eventTypes: {},
    cta: {
      organize: "Organizar um encontro na minha cidade",
      join: "Aderir a um círculo"
    }
  },
  fr: {
    title: "Résultats & Terrain",
    subtitle: "Le mouvement en action",
    description: "Nos actions concrètes, mois après mois. Un mouvement se juge à ses résultats.",
    timeline: [
      {
        month: "Janvier 2025",
        events: [
          {
            id: "t-001",
            type: "reunion",
            title: "Lancement du Cercle d'Abidjan-Plateau",
            location: "Abidjan, Plateau",
            date: "2025-01-15",
            objective: "Créer le premier cercle local structuré",
            result: "42 membres fondateurs, bureau élu",
            image: null
          },
          {
            id: "t-002",
            type: "formation",
            title: "Formation 'Argumenter nos propositions'",
            location: "En ligne",
            date: "2025-01-20",
            objective: "Former 30 volontaires à la communication politique",
            result: "28 participants certifiés",
            image: null
          }
        ]
      },
      {
        month: "Février 2025",
        events: [
          {
            id: "t-003",
            type: "action",
            title: "Publication du Scorecard Q1",
            location: "National",
            date: "2025-02-01",
            objective: "Rendre publiques nos positions sur 5 textes majeurs",
            result: "3 200 vues, 450 partages",
            image: null
          },
          {
            id: "t-004",
            type: "reunion",
            title: "Rencontre avec les PME de Bouaké",
            location: "Bouaké",
            date: "2025-02-10",
            objective: "Présenter le programme '1000 PME Fournisseurs'",
            result: "15 entreprises intéressées, 3 partenariats signés",
            image: null
          }
        ]
      }
    ],
    eventTypes: {
      reunion: { label: "Réunion", icon: "Users", color: "violet" },
      formation: { label: "Formation", icon: "GraduationCap", color: "blue" },
      action: { label: "Action", icon: "Zap", color: "yellow" },
      partenariat: { label: "Partenariat", icon: "Handshake", color: "green" }
    },
    cta: {
      organize: "Organiser une rencontre dans ma ville",
      join: "Rejoindre un cercle"
    }
  },
  en: {
    title: "Results & Field",
    subtitle: "The movement in action",
    description: "Our concrete actions, month after month. A movement is judged by its results.",
    timeline: [],
    eventTypes: {},
    cta: {
      organize: "Organize a meeting in my city",
      join: "Join a circle"
    }
  }
};

// ===========================================
// EVENEMENTS DATA
// ===========================================
export const evenementsData = {
  pt: {
    title: "Eventos",
    subtitle: "Próximos encontros",
    upcoming: [],
    past: [],
    eventTypes: {},
    cta: {
      register: "Inscrever-se",
      full: "Completo",
      addToCalendar: "Adicionar ao calendário",
      proposeEvent: "Propor um evento"
    }
  },
  fr: {
    title: "Événements",
    subtitle: "Rencontres à venir",
    upcoming: [
      {
        id: "ev-001",
        title: "Cercle de réflexion : Éducation",
        type: "cercle",
        date: "2025-02-20",
        time: "18h00 - 20h00",
        location: "Abidjan, Cocody",
        address: "Salle communale de Cocody",
        description: "Discussion ouverte sur nos propositions éducatives : calendrier scolaire, programme Éveil & Pratique, contrat École-Parents.",
        capacity: 50,
        registered: 23,
        isOnline: false
      },
      {
        id: "ev-002",
        title: "Webinaire : Comprendre le Scorecard",
        type: "webinaire",
        date: "2025-02-25",
        time: "19h00 - 20h30",
        location: "En ligne",
        address: "Lien envoyé après inscription",
        description: "Présentation de notre méthode d'analyse des textes et de notre posture constructive.",
        capacity: 200,
        registered: 87,
        isOnline: true
      },
      {
        id: "ev-003",
        title: "Rencontre terrain : Gagnoa",
        type: "terrain",
        date: "2025-03-05",
        time: "10h00 - 13h00",
        location: "Gagnoa",
        address: "Place de la Mairie",
        description: "Rencontre avec les acteurs économiques locaux pour présenter nos propositions sur les PME et l'agriculture.",
        capacity: 100,
        registered: 45,
        isOnline: false
      }
    ],
    past: [
      {
        id: "ev-past-001",
        title: "Lancement officiel ADA",
        date: "2025-01-10",
        location: "Abidjan",
        recap: "Plus de 200 participants, 15 médias présents. Voir le récap sur notre page Terrain."
      }
    ],
    eventTypes: {
      cercle: { label: "Cercle de réflexion", color: "violet" },
      webinaire: { label: "Webinaire", color: "blue" },
      terrain: { label: "Rencontre terrain", color: "green" },
      formation: { label: "Formation", color: "yellow" }
    },
    cta: {
      register: "S'inscrire",
      full: "Complet",
      addToCalendar: "Ajouter au calendrier",
      proposeEvent: "Proposer un événement"
    }
  },
  en: {
    title: "Events",
    subtitle: "Upcoming meetings",
    upcoming: [],
    past: [],
    eventTypes: {},
    cta: {
      register: "Register",
      full: "Full",
      addToCalendar: "Add to calendar",
      proposeEvent: "Propose an event"
    }
  }
};

// ===========================================
// NOTES DE PROPOSITION DATA
// ===========================================
export const notesData = {
  pt: {
    title: "Notas de proposta",
    subtitle: "As nossas fichas de proposta em 1 página",
    description: "Documentos curtos, operacionais, para compreender as nossas propostas em 5 minutos.",
    notes: [],
    cta: {
      download: "Descarregar PDF",
      share: "Partilhar",
      all: "Todas as notas"
    }
  },
  fr: {
    title: "Notes de proposition",
    subtitle: "Nos fiches de proposition en 1 page",
    description: "Des documents courts, opérationnels, pour comprendre nos propositions en 5 minutes.",
    notes: [
      {
        id: "note-001",
        title: "Calendrier scolaire bi-saisonnier",
        tags: ["Social", "Éducation", "Local CI"],
        date: "2025-01-15",
        problem: "Le rythme scolaire actuel ne tient pas compte des réalités climatiques : chaleur, pluies, maladies saisonnières. Résultat : absentéisme, baisse de concentration, inégalités territoriales.",
        proposal: "Adapter le calendrier à un pays qui vit au rythme de deux saisons, avec un cadre national stable et une marge d'ajustement locale encadrée (±15 jours).",
        implementation: [
          "Pilotes sur 2-3 zones climatiques pendant 1 an",
          "Cadre national (rentrées, examens) + ajustement local",
          "Mesures 'École fraîche' : ventilation, ombrage, horaires adaptés"
        ],
        indicators: [
          "Taux d'absentéisme (-20% visé)",
          "Résultats aux examens (+5 points visés)",
          "Satisfaction des familles (enquête)"
        ],
        feasibility: "Coût modéré, nécessite coordination ministère/régions. Délai : 1 an pour les pilotes, 2 ans pour généralisation."
      },
      {
        id: "note-002",
        title: "Programme 1000 PME Fournisseurs",
        tags: ["Économique", "PME", "Emploi"],
        date: "2025-01-20",
        problem: "Les PME ivoiriennes restent trop faibles pour accéder aux marchés publics et aux grands groupes : normes, qualité, délais, financement.",
        proposal: "Un programme national pour structurer 1000 PME capables de devenir fournisseurs de l'État et des grandes entreprises.",
        implementation: [
          "Label 'PME Fournisseur' avec critères simples",
          "Formations ciblées (normes, coûts, logistique)",
          "Plateforme d'accès aux appels d'offres",
          "Mécanisme de garantie/affacturage"
        ],
        indicators: [
          "Nombre de PME labellisées (1000 sur 3 ans)",
          "Marchés publics attribués à des PME (+30%)",
          "Emplois créés (10 000 visés)"
        ],
        feasibility: "Budget estimé : 5 milliards FCFA sur 3 ans. Partenariats banques/État nécessaires."
      },
      {
        id: "note-003",
        title: "Budget citoyen local",
        tags: ["Institutionnel", "Gouvernance", "Démocratie"],
        date: "2025-02-01",
        problem: "Les citoyens perçoivent les décisions budgétaires comme lointaines et opaques. Cela nourrit la défiance.",
        proposal: "Affecter 1% à 3% des budgets locaux à des projets choisis par les citoyens via une consultation simple et transparente.",
        implementation: [
          "Règlement standard (éligibilité, plafonds)",
          "Garde-fous anti-capture : rotation, transparence, audit",
          "Reporting public trimestriel",
          "Évaluation annuelle"
        ],
        indicators: [
          "Taux de participation citoyenne",
          "Délais de réalisation des projets",
          "Satisfaction des habitants (enquête)"
        ],
        feasibility: "Coût nul (réallocation). Nécessite volonté politique locale. Pilote possible en 6 mois."
      }
    ],
    cta: {
      download: "Télécharger PDF",
      share: "Partager",
      all: "Toutes les notes"
    }
  },
  en: {
    title: "Policy Notes",
    subtitle: "Our 1-page policy briefs",
    description: "Short, operational documents to understand our proposals in 5 minutes.",
    notes: [],
    cta: {
      download: "Download PDF",
      share: "Share",
      all: "All notes"
    }
  }
};

// ===========================================
// PRESSE DATA
// ===========================================
export const presseData = {
  pt: {
    title: "Imprensa & Media",
    subtitle: "Kit media e recursos",
    bio: {
      short: "A Aliança Democrática Africana (ADA) é um movimento político pan-africano fundado numa postura construtiva e contributiva.",
      long: ""
    },
    keyMessages: [],
    assets: { logos: [], photos: [], guidelines: "" },
    contact: {},
    cta: {
      downloadKit: "Descarregar Media Kit",
      contact: "Contactar gabinete de imprensa"
    }
  },
  fr: {
    title: "Presse & Médias",
    subtitle: "Kit média et ressources",
    bio: {
      short: "L'Alliance Démocratique Africaine (ADA) est un mouvement politique fondé sur une posture constructive et contributive. L'ADA propose une transformation institutionnelle, économique et sociale pour une Côte d'Ivoire souveraine.",
      long: "L'Alliance Démocratique Africaine (ADA) est un mouvement politique qui se distingue par sa posture constructive et contributive. Ni dans le soutien aveugle, ni dans l'opposition systématique, l'ADA juge chaque texte sur le fond : elle soutient ce qui est utile, amende ce qui est perfectible, et combat ce qui est dangereux.\n\nL'ADA porte un projet de transformation articulé autour de trois axes : la transformation institutionnelle (provinces, Sénat territorial, panel citoyen), la transformation économique (1000 PME fournisseurs, choc logistique agricole), et la transformation sociale (calendrier scolaire adapté, service civique territorial).\n\nL'ADA publie régulièrement son Scorecard (positions sur les textes) et des Notes de proposition (fiches en 1 page) pour démontrer sa méthode et sa transparence."
    },
    keyMessages: [
      "Constructive. Contributive. — Une posture qui juge sur le fond, pas sur l'étiquette.",
      "Souveraineté économique territoriale — Chaque province devient un centre de production.",
      "Transparence totale — Scorecard public, comptes trimestriels, positions argumentées.",
      "Gagner par la preuve — Des propositions chiffrées, des résultats mesurables.",
      "L'Afrique arrive à un point de bascule — Il est temps de proposer, pas seulement de critiquer."
    ],
    assets: {
      logos: [
        { name: "Logo principal (PNG)", format: "PNG", size: "1200x1200", url: null },
        { name: "Logo principal (SVG)", format: "SVG", size: "Vectoriel", url: null },
        { name: "Logo blanc (PNG)", format: "PNG", size: "1200x1200", url: null }
      ],
      photos: [
        { name: "Photo officielle 1", description: "Leadership", url: null },
        { name: "Photo officielle 2", description: "Événement", url: null }
      ],
      guidelines: "Le logo ADA doit toujours être utilisé sur fond clair ou avec la version blanche sur fond sombre. Espace minimum autour du logo : hauteur du 'A'. Ne pas déformer, recolorer ou modifier le logo."
    },
    contact: {
      email: "presse@ada.org",
      phone: "+225 XX XX XX XX",
      whatsapp: "+225 XX XX XX XX"
    },
    cta: {
      downloadKit: "Télécharger le Media Kit",
      contact: "Contacter le service presse"
    }
  },
  en: {
    title: "Press & Media",
    subtitle: "Media kit and resources",
    bio: {
      short: "The African Democratic Alliance (ADA) is a pan-African political movement founded on a constructive and contributive stance.",
      long: ""
    },
    keyMessages: [],
    assets: { logos: [], photos: [], guidelines: "" },
    contact: {},
    cta: {
      downloadKit: "Download Media Kit",
      contact: "Contact press office"
    }
  }
};
